import { dataHora } from '../lib/datas'
import { TEXTOS } from '../lib/glossario'

/**
 * A procedência de um texto escrito por máquina — qual modelo, quando, e o que ele não é.
 *
 * **Existe porque a mesma frase estava escrita duas vezes.** O apoio da IA no chamado e o painel do
 * comitê na GMUD diziam cada um a sua versão de "análise automática, apoio à decisão", e a segunda
 * cópia é sempre onde a divergência começa: basta alguém melhorar uma para o sistema passar a
 * afirmar duas coisas diferentes sobre o que um parecer de IA é. Com a leitura do fechamento do mês
 * seriam três.
 *
 * **Parecer sem procedência é opinião com cara de fato.** O modelo e o instante não são detalhe
 * técnico: eles são o que permite, meses depois, responder "quem escreveu isto, e sobre que versão
 * do dado?". É a mesma razão de `coletadoEm` existir nos chamados.
 *
 * **E o selo diz o limite, não só a origem.** Quem lê um texto bem escrito ao lado de um número
 * tende a ler os dois como se tivessem a mesma autoridade. A frase separa: nenhum número desta tela
 * foi calculado por ele, e a decisão é sempre da fiscalização (Regra nº 3).
 *
 * @param props o modelo declarado pelo provedor e quando o texto foi escrito
 * @returns a linha de procedência
 */
export function SeloDeMaquina({ modelo, quando }: { modelo: string | null; quando: string | null }) {
  const t = TEXTOS.seloDeMaquina

  return (
    <p className="text-xs text-slate-400" aria-label={t.rotulo}>
      {t.frase(modelo ?? t.semModelo, dataHora(quando))}
    </p>
  )
}
